import React from 'react';

const useHttp = () => {
    const [error, setError] = React.useState<Record<string, string> | null>(null);

    const activeHttpRequests = React.useRef<any[]>([]);

    const clearError = () => {
        setError(null);
    };

    const sendRequest = React.useCallback(async (url, method = 'GET', body = null, headers = {}) => {
        const httpAbortController = new AbortController();
        activeHttpRequests.current.push(httpAbortController);

        try {
            const response = await fetch(url, {
                method,
                body,
                headers,
                signal: httpAbortController.signal,
            });

            if (!response.ok) {
                throw new Error('Error occurred while fetching API data');
            }

            const responseData = await response.json();
            activeHttpRequests.current = activeHttpRequests.current.filter(
                (reqCtrl) => reqCtrl !== httpAbortController
            );

            return responseData;
        } catch (err: any) {
            setError({ message: err.message });
            throw err;
        }
    }, []);

    React.useEffect(() => {
        return () => {
            activeHttpRequests.current.forEach((abortCtrl: any) => abortCtrl.abort());
        };
    }, []);

    return { error, sendRequest, clearError };
};

export default useHttp;
